const components = {};
const muiFiles = require.context("../mui", false, /\.vue$/);

muiFiles.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = muiFiles(fileName);
  // 获取组件的 PascalCase 命名
  const componentName = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");

  components[componentName] = componentConfig.default || componentConfig;
});

export default {
  install(Vue) {
    for (let key in components) {
      Vue.component(key, components[key]);
    }
  },
};
